export default {
    version: "313",
    buildNumber: "629",
    baseUrl: "https://cf-st.sc-cdn.net/d/0HAchv75u9EAJsMvZsIut?go=IgsKCTIBBEgBUFxgAQ%3D%3D&uc=92",
};
